module.exports = __webpack_public_path__ + "img/logo_1.89fd629d.jpeg";